// PRODUCT DESCRIPTION READ MORE/LESS
// VARIANT


function toggleDescription(button) {
  const moreContent = button.previousElementSibling;
  const isExpanded = moreContent.classList.contains('expanded');

  if (isExpanded) {
    moreContent.classList.remove('expanded');
    button.textContent = 'Περισσότερα';
  } else {
    moreContent.classList.add('expanded');
    button.textContent = 'Λιγότερα';
  }
}

class StockFilter extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.isChecked = this.dataset.isChecked === 'true';
    this.filterLabel = this.dataset.filterLabel || 'In Stock Only'; // Fallback if not provided
    this.init();
  }

  init() {
    this.render();
    this.setupEventListeners();
  }

  render() {
    this.innerHTML = `
      <div class="toggle-container">
        <h4 class="toggle-label [ txt-16 color-black bold ] ">${this.filterLabel}</h4>
        <div class="toggle-switch-wrapper">
          <input 
            type="checkbox" 
            name="filter.v.availability" 
            value="1" 
            id="InStockOnly-${this.sectionId}"
            class="toggle-switch"
            ${this.isChecked ? 'checked' : ''}
          >
          <label class="toggle-switch-slider" for="InStockOnly-${this.sectionId}"></label>
        </div>
      </div>
    `;
  }

  setupEventListeners() {
    const checkbox = this.querySelector(`#InStockOnly-${this.sectionId}`);
    if (checkbox) {
      checkbox.addEventListener('change', this.handleFilterChange.bind(this));
    }
  }

  handleFilterChange(event) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    // Remove any existing availability filters
    params.delete('filter.v.availability');

    // Add the filter if checked
    if (event.target.checked) {
      params.append('filter.v.availability', '1');
    }

    // Update URL and navigate
    url.search = params.toString();
    window.location.href = url.toString();
  }
}

customElements.define('stock-filter', StockFilter);


